import { Box, Skeleton } from '@mui/material';
import { INSPECT_COLUMN_WIDTH } from '../../utils/ssbStyles';

const cardSx = {
  backgroundColor: '#fff',
  border: '1px solid #CBD5E0',
  borderRadius: '8px',
  boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
  padding: '20px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

const lineSx = { backgroundColor: '#edf2f7' };

function DefinePreviewSkeleton() {
  return (
    <Box sx={{ display: 'flex', gap: '20px', alignItems: 'stretch' }}>
      <Box sx={{ ...cardSx, flexGrow: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
          <Skeleton sx={lineSx} variant='text' width='45%' height={20} />
          <Skeleton sx={lineSx} variant='text' width={60} height={20} />
        </Box>
        <Skeleton sx={lineSx} variant='text' width='60%' height={16} />
        <Skeleton sx={lineSx} variant='text' width='55%' height={16} />
        <Skeleton sx={lineSx} variant='text' width='40%' height={16} />
        <Box sx={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Skeleton sx={lineSx} variant='text' width='35%' height={16} />
          <Skeleton sx={lineSx} variant='text' width='50%' height={16} />
        </Box>
      </Box>
      <Box sx={{ ...cardSx, width: INSPECT_COLUMN_WIDTH, flexShrink: 0 }}>
        <Skeleton sx={lineSx} variant='text' width='55%' height={16} />
        <Skeleton sx={lineSx} variant='text' width='70%' height={16} />
        <Skeleton sx={lineSx} variant='text' width='40%' height={28} />
        <Skeleton sx={lineSx} variant='rounded' width='100%' height={8} />
        <Skeleton sx={lineSx} variant='text' width='80%' height={16} />
        <Skeleton sx={lineSx} variant='text' width='50%' height={16} />
      </Box>
    </Box>
  );
}

export default DefinePreviewSkeleton;
